import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM6.453 3.996H4.391v8.005h2.062V3.996Zm3.149 0h2.062v8.005H9.602V3.996Zm-2.74 5.378A2.552 2.552 0 0 0 9.182 6.61a2.552 2.552 0 0 0-2.322 2.765Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }